// Petit slug ascii stable, utilise pour deriver un _id de noeud de taxonomie
// a partir d'un libelle saisi (categorie ou sous-categorie).
// Plage Unicode des diacritiques combinants (U+0300-U+036F), construite via
// charCode plutot qu'un echappement litteral pour eviter tout souci d'encodage.
const COMBINING_MARKS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');

// Minuscule + sans accents, mais garde les espaces/ponctuation — contrairement
// à slugify(), destiné à comparer/rechercher du texte plutôt qu'à fabriquer un
// identifiant. Utilisé par la recherche insensible à la casse et aux accents.
export const normalizeForSearch = (text) => (text || '')
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .toLowerCase()
    .trim();

export const slugify = (label) => normalizeForSearch(label)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
